import { createSlice } from "@reduxjs/toolkit";
import { FilterStateUser } from "./types";

const INITIAL_STATE: FilterStateUser = {
  filters: {
    search: "",
    meta: {
      page: 1,
    },
  },
};

const userFilterSlice = createSlice({
  name: "userFilter",
  initialState: INITIAL_STATE,
  reducers: {
    setUserFilter(state, action) {
      state.filters[action.payload.key] = action.payload.value;
    },
  },
});

export const { setUserFilter } = userFilterSlice.actions;
export default userFilterSlice.reducer;
